import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useBarometerItemReserveRelease() {
  const { startListen } = useWebSocketStore()
  const { updateBarometerCarData } = useUpdateCar()

  const itemReserveRelease = () => {
    startListen({
      eventName: 'premium.ITEM_RESERVE_RELEASE',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, itemId, auctionId, free } = event.context

        updateBarometerCarData(auctionId, itemId || carId, (data) => {
          return {
            ...data,
            state: free ? 'SOLD' : 'NOT_SOLD',
          }
        })
      },
    })
  }

  return { itemReserveRelease }
}
